// extracted by mini-css-extract-plugin
module.exports = {"container":"PositionTip_container__3vUY1","avatar":"PositionTip_avatar__3Gyxp","content":"PositionTip_content__asR-I"};